interface TimerLabelProps {
  days: number
  hours: number
  minutes: number
  seconds: number
}

const TimerLabel = ({ days, hours, minutes, seconds }: TimerLabelProps) => (
  <>
    {days > 0 && (
      <>
        {days}
        <abbr>j</abbr> 
      </>
    )}
    {(days > 0 || hours > 0) && (
      <>
        {hours}
        <abbr>h</abbr> 
      </>
    )}
    {minutes}
    <abbr>mn</abbr> {seconds}
    <abbr>s</abbr>
  </>
)
export default TimerLabel
